import antdEnUS from "antd/es/locale/en_US";
import antdFrFR from "antd/es/locale/fr_FR";
import antdEsES from "antd/es/locale/es_ES";
import LanguageDetector from "i18next-browser-languagedetector";
import en from "./locales/en_US.json";
import fr from "./locales/fr_FR.json";
import es from "./locales/es_ES.json";
import i18n from "i18next";
import { initReactI18next } from "react-i18next";

export const resources = {
  en: {
    translation: en,
    antd: antdEnUS,
  },
  es: {
    translation: es,
    antd: antdEsES,
  },
  fr: {
    translation: fr,
    antd: antdFrFR,
  },
};

// const getInitialLocale = () => {
//   try {
//     const persistedRoot = localStorage.getItem("persist:root");
//     if (!persistedRoot) return THEME_CONFIG.locale;

//     const parsedRoot = JSON.parse(persistedRoot);
//     const themeState = JSON.parse(parsedRoot.theme);
//     return themeState.locale || THEME_CONFIG.locale;
//   } catch {
//     return THEME_CONFIG.locale;
//   }
// };

const supportedLanguages = ["en", "es", "fr"];
// const initialLocale = getInitialLocale();

i18n
  .use(LanguageDetector)
  .use(initReactI18next)
  .init({
    resources,
    fallbackLng: "en",
    supportedLngs: supportedLanguages,
    nonExplicitSupportedLngs: true,
    load: "languageOnly",
    cleanCode: true,
    lowerCaseLng: true,
    returnNull: false,
    detection: {
      order: ["localStorage", "navigator"],
      caches: ["localStorage"],
      lookupLocalStorage: "appLanguage",
    },
    interpolation: {
      escapeValue: false,
    },
  });

export default i18n;
